import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimePlaybackLoopIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M3 12C3 9.23999 5.24 6.99999 8 6.99999H16V9.99999L21.38 6.41999C21.68 6.21999 21.68 5.78999 21.38 5.58999L16 2.00999V5.00999H8C4.14 5.00999 1 8.14999 1 12.01C1 12.56 1.45 13.01 2 13.01C2.55 13.01 3 12.56 3 12.01V12Z"
        fill={color}
      />
      <path
        d="M22 11C21.45 11 21 11.45 21 12C21 14.76 18.76 17 16 17H8V14L2.62 17.58C2.32 17.78 2.32 18.21 2.62 18.41L8 21.99V18.99H16C19.86 18.99 23 15.85 23 11.99C23 11.44 22.55 10.99 22 10.99V11Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimePlaybackLoopIcon.displayName = 'TimePlaybackLoopIcon';
